import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  TableContainer,
  LinearProgress,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
} from "@mui/material";
import { Done as TipIcon, Edit as EditIcon } from "@mui/icons-material";
import TipIconNew from "../../assets/icons/tip-icon.svg";
import PdfIcon from "../../assets/icons/pdf-icon.svg";
import AppointmentCalenderIcon from "../../assets/icons/appointment-calender-icon.svg";
import { useAppContext } from "../../context/AppContext";
import { GetAllUserAppointment } from "../../helpers/Appointment";
import moment from "moment";
import Toast from "../../components/toast";
import { alignItems, display, Grid, width } from "@mui/system";

import { GetAppointmentDetails } from "../../helpers/Appointment";
import { downloadMedicalFormByChatId } from "../../helpers/Downloads";
import { minutesToTime } from "../../constants/timeUtils";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";

const PastAppointmentDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { appointmentId } = location.state || {};
  const { userData, isMobile } = useAppContext();

  const [isLoading, setIsLoading] = useState(false);
  const [appointmentData, setAppointmentData] = useState([]);

  const [appointments, setAppointments] = useState([]);
  const [progress, setProgress] = useState(95);

  const [openReportUpload, setOpenReportUpload] = useState(false);


  const GetAllAppointmenthanlder = async (_appointmentId) => {
    setIsLoading(true);
    const response = await GetAppointmentDetails(_appointmentId);
    if (response.statusCode === 200 && response.isSuccess === true) {
      const data = response.data;
      setAppointmentData(data);
    } else {
      Toast.error(response.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (appointmentId) {
      GetAllAppointmenthanlder(appointmentId);
    }
  }, [appointmentId]);

  const handleViewMedicalForm = async (formtType) => {
    downloadMedicalFormByChatId(appointmentData.chatId, formtType);
  };

  const styles = {
    tableCell: {
      color: "#6B6B6B",
    },
    contentBox: {
      p: 2,
      my: 2,
      borderRadius: 2,
      border: "1px solid #e0e0e0",
      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
      backgroundColor: "#ffffff",
    },
    contentBoxInner: {
      display: "flex",
      gap: 1,
      flexWrap: "wrap",
      width: "300px",
      my: 3,
      p: 2,
      borderRadius: { xs: "12px", sm: "12px" },
      boxShadow: "0 5px 10px rgba(0,0,0,0.3)",
    },
  };

  return (
    <Box sx={styles.TableContainer}>
      <Typography
        variant="body2"
        color="primary"
        mb={2}
        sx={{
          textDecoration: "underline",
          cursor: "pointer",
        }}
        onClick={() => navigate(-1)}
      >
        <KeyboardBackspaceOutlinedIcon
          fontSize="small"
          sx={{ verticalAlign: "middle", mr: 0.5, fontWeight: "medium" }}
        />
        Back
      </Typography>
      <Box
        style={{
          width: "100%",
          border: "1px solid #E8E8E8",
          borderRadius: "12px",
          padding: "10px 15px",
          backgroundColor: "#fff",
        }}
      >
        <Box sx={{ my: 1 }}>
          <Typography fontSize={"24px"} className="sf-medium sf-medium--dark">
            Past Appointment
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Box sx={styles.contentBox}>
                <Typography
                  fontSize={"16px"}
                  sx={{ mb: 1 }}
                  className="sf-bold sf-bold--dark"
                >
                  Uploaded Documents
                </Typography>
                <Typography
                  fontSize={"14px"}
                  sx={{ mb: 1 }}
                  className="sf-regular sf-regular--dark"
                >
                  You’ve uploaded PME and POLST Medical forms.
                </Typography>
                <Box className="background-light" sx={styles.contentBoxInner}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={PdfIcon}
                      width={"36px"}
                      height={"36px"}
                      style={{ marginRight: "5px" }}
                    />
                    <Box>
                      <Typography
                        sx={{ fontSize: "18px" }}
                        className="sf-bold sf-bold--primary"
                      >
                        PME Medical Form
                      </Typography>
                      <Typography
                        sx={{ fontSize: "12px" }}
                        className="sf-regular sf-regular--dark"
                      >
                        Document
                      </Typography>
                    </Box>
                  </Box>
                  <Button
                    variant="outlined"
                    size="small"
                    className="sf-medium sf-medium--light background-primary"
                    sx={{
                      width: "100%",
                      borderColor: "#8b5cf6",
                      textTransform: "none",
                      borderRadius: "8px",
                      padding: "5px 20px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleViewMedicalForm("PME")}
                  >
                    Download PDF
                  </Button>
                </Box>
                {appointmentData?.evaluationType === "PME & POLST" && (
                  <Box className="background-light" sx={styles.contentBoxInner}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={PdfIcon}
                        width={"36px"}
                        height={"36px"}
                        style={{ marginRight: "5px" }}
                      />
                      <Box>
                        <Typography
                          sx={{ fontSize: "18px" }}
                          className="sf-bold sf-bold--primary"
                        >
                          POLST Medical Form
                        </Typography>
                        <Typography
                          sx={{ fontSize: "12px" }}
                          className="sf-regular sf-regular--dark"
                        >
                          Document
                        </Typography>
                      </Box>
                    </Box>
                    <Button
                      variant="outlined"
                      size="small"
                      className="sf-medium sf-medium--light background-primary"
                      sx={{
                        width: "100%",
                        borderColor: "#8b5cf6",
                        textTransform: "none",
                        borderRadius: "8px",
                        padding: "5px 20px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleViewMedicalForm("POLST")}
                    >
                      Download PDF
                    </Button>
                  </Box>
                )}
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Grid container spacing={1}>
                <Grid size={{ xs: 12 }}>
                  <Box sx={styles.contentBox}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Box sx={{ width: "80%" }}>
                        <Typography
                          fontSize={"16px"}
                          sx={{ mb: 1 }}
                          className="sf-bold sf-bold--dark"
                        >
                          Appointment Details
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            fontSize={"14px"}
                            sx={{ mb: 1 }}
                            className="sf-regular sf-regular--dark"
                          >
                            Date:&nbsp;
                          </Typography>
                          <Typography
                            fontSize={"14px"}
                            sx={{ mb: 1 }}
                            className="sf-regular sf-regular--primary"
                          >
                            {appointmentData.appointmentDate
                              ? moment(appointmentData.appointmentDate).format(
                                "MMMM Do YYYY",
                              )
                              : "N/A"}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            fontSize={"14px"}
                            sx={{ mb: 1 }}
                            className="sf-regular sf-regular--dark"
                          >
                            Time:&nbsp;
                          </Typography>
                          <Typography
                            fontSize={"14px"}
                            sx={{ mb: 1 }}
                            className="sf-regular sf-regular--primary"
                          >
                            {appointmentData.startMinute &&
                              appointmentData.endMinute
                              ? `${minutesToTime(appointmentData.startMinute)} - ${minutesToTime(appointmentData.endMinute)}`
                              : ""}
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={AppointmentCalenderIcon}
                          width={"50px"}
                          height={"50px"}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default PastAppointmentDetail;
